import { AdminAppState, EventEntry } from '../../state';
import { getEvent } from './get-event';

export const getEventId = (eventKey: string) => (
  store: AdminAppState,
): EventEntry['event']['id'] => getEvent(eventKey)(store).id;
